/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React, {useContext, useEffect, useState} from "react";
import {Badge, Button, Card, Col, Form, Input, message, Row, Space} from 'antd';
import {LockOutlined, UserOutlined, KeyOutlined} from '@ant-design/icons';
import {Link, useHistory} from "react-router-dom";
import AuthService from "../../service/auth.service";
import UserService from "../../service/user.service";
import {AuthContext} from "../../context/auth.context";
import {TraderService} from "../../service/trader.service";
import {IfTruthy} from "../../component/if.equal.component";
import {EncryptionSVC} from "../../index.wasm";


let authSVC = new AuthService()
const Login = (props: any) => {
    let authContext = useContext(AuthContext)
    let userSVC = new UserService(authSVC, authContext)
    let [loading, setLoading] = useState(false)
    let history = useHistory()
    const [redirecting, setRedirecting] = useState(false)
    const [showTwoFactor, setShowTwoFactor] = useState(false)
    const [email, setEmail] = useState(props?.location?.state?.email || '')
    const [pass, setPass] = useState(props?.location?.state?.password || '')
    const [triggerLogIn, setTriggerLogIn] = useState(props?.location?.state?.login || false)

    useEffect(()=>{
        EncryptionSVC.waitForKey().then()
        if(triggerLogIn){
            setTriggerLogIn(false)
            onFinish({
                m: email,
                p: pass,
            }).then()
        }
    }, [])

    useEffect(()=>{
        if(redirecting){return}
        if(authSVC.hasToken()){
            afterLoggedIn()
        }
    }, [authContext.token])

    const afterLoggedIn = ()=>{
        setRedirecting(true)
        let path = props?.location?.state?.from?.pathname
        let state = props?.location?.state?.from?.state
        if(path && path != "login"){
            history.replace(path, state)
        } else {
            history.replace("/")
        }
    }

    const onFinish = async (values: any) => {
        setLoading(true)
        try{
            let twoFactor = values.twoFactorCode;
            if(!values.hasF){
                let twoFactorInfo = await userSVC.hasTwoFactor(values.m)
                if(twoFactorInfo.enabled){
                    setShowTwoFactor(true)
                    setEmail(values.m)
                    setPass(values.p)
                    return
                }
            }


            let info = await userSVC.login(values.m, values.p, twoFactor)
            if(!info.token){
                message.error('bad credentials')
                return
            }
            message.success('logged in ', 1)
            authContext.setToken(info.token)
            afterLoggedIn()

        }catch (e){
            console.error(e)
            let unauthorized = e?.status == 401
            if(unauthorized){
                message.error('bad credentials')
                return;
            }
            let msg = e.rawErrorMessage
            if(msg){
                message.error(msg)
                return
            }
            message.error('something went wrong')
        }finally {
            setLoading(false)
            if(values.hasF){
                setShowTwoFactor(false)
            }
        }
    };

    return (
        <Row>
            <Col xs={{span: 24}} lg={{span: 12, offset: 6}}>
                <Badge.Ribbon placement={'start'} text="Login">
                    <Card style={{paddingTop:40}} >
                    <Form
                        size={'large'}
                        name="normal_login"
                        className="login-form"
                        initialValues={{ remember: true, m: email, p: pass }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="m"
                            style={{display: showTwoFactor ? "none" : undefined}}
                            rules={[{ required: true, message: 'Email required' }]}
                        >
                            <Input prefix={<UserOutlined className="site-form-item-icon" />}
                                   autoComplete="new-password"
                                   placeholder="Email"
                                   onChange={(v)=>setEmail(v.target.value)}
                            />
                        </Form.Item>
                        <Form.Item
                            name="p"
                            style={{display: showTwoFactor ? "none" : undefined}}
                            rules={[{ required: true, message: 'Password required' }]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder="Password"
                                autoComplete="new-password"
                            />
                        </Form.Item>

                        <IfTruthy val={showTwoFactor}>
                            <Form.Item
                                name="twoFactorCode"
                                rules={[{ required: true, message: 'Two factor code required' }]}
                            >
                                <Input
                                    prefix={<KeyOutlined className="site-form-item-icon" />}
                                    type="text"
                                    placeholder="6 digit code"
                                    autoComplete="new-password"
                                />

                            </Form.Item>

                            <Form.Item
                                name="hasF"
                                style={{display: "none"}}
                                initialValue={true}
                                rules={[{ required: true, message: 'Password required' }]}
                            >
                                <Input
                                    type="hidden"
                                />

                            </Form.Item>
                        </IfTruthy>

                        <Form.Item>
                            <Space>
                                <Button type="primary" loading={loading} htmlType="submit" className="login-form-button">
                                    {loading ? "Logging in..." : "Log in"}
                                </Button>
                                Or <Link to="/register">register now!</Link>
                            </Space>

                            <br/>
                            <br/>
                            <Link to={{
                                pathname: '/forgot',
                                state: {email: email}
                            }} style={{fontSize: 10}}>Forgot Password?</Link>
                        </Form.Item>
                    </Form>
                </Card>
                </Badge.Ribbon>
            </Col>
        </Row>

    );
};

export {Login}
